export const classDoNotCollapseQueryBuilderOnClick = "do-not-collapse-query-builder-on-click";

/**
 * Indicates whether an `Element`, when clicked, should prevent collapsing the popover menus of the
 * querybuilder.
 *
 * For example, when clicking on a field in the object `<Inspector>` while the `group by` menu is
 * open, we would like to toggle whether the field is included in the `groupby` clause, but also
 * *NOT* close the `group by` menu which displays which fields we're grouping by.
 *
 * This is done by checking for a special CSS class in `Element` or any of its ancestors.
 */
export function hasClassDoNotCollapseQueryBuilderOnClick(e: Element | null) {
	const closest = e?.closest(`.${classDoNotCollapseQueryBuilderOnClick}`);
	return closest !== undefined && closest !== null;
}
